import { ValidationErrors, ValidatorFn } from '@angular/forms';

export function regexValidatorFn(
  regex: RegExp,
  error: ValidationErrors
): ValidatorFn {
  return (control) => {
    const value = control.value;
    const isEmpty = value === null || value === undefined || value === '';

    if (isEmpty) {
      return regex.source === REQUIRED_REGEX ? error : null;
    }

    const valid = regex.test(value);
    return valid ? null : error;
  };
}

export const REQUIRED_REGEX = '^.+$';
